import { apiClient } from "./api";

export const systemApi = {
  readFile: (path: string) =>
    apiClient.get<{ content: any }>(
      `/eval/api/files/read?path=${encodeURIComponent(path)}`,
    ),
};
